import { render, staticRenderFns } from "./InstructionsTable.vue?vue&type=template&id=444b0faa"
import script from "./InstructionsTable.vue?vue&type=script&lang=js"
export * from "./InstructionsTable.vue?vue&type=script&lang=js"
import style0 from "./InstructionsTable.vue?vue&type=style&index=0&id=444b0faa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports